import { render, staticRenderFns } from "./returnSupplierDetails.vue?vue&type=template&id=9fba06ae&scoped=true"
import script from "./returnSupplierDetails.vue?vue&type=script&lang=js"
export * from "./returnSupplierDetails.vue?vue&type=script&lang=js"
import style0 from "./returnSupplierDetails.vue?vue&type=style&index=0&id=9fba06ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fba06ae",
  null
  
)

export default component.exports